module.exports = __webpack_public_path__ + "img/letsbutterfly-wordmark.ca9c9afe.png";